/***
*
*   FOOTER (homepage)
*   Static homepage footer
*
**********/

import React from 'react';
import { Animate, Row, Content, Link } from 'components/lib'
import Style from './footer.module.scss';

export function Footer(props){

  return (
    <Animate type='slideup'>
      <footer className={ Style.footer }>
        <Row>
          <Content>

            <nav>
            <Link url='https://ledgerview.app' text='Home'/>
            <Link url='/signin' text='Sign in'/>
            <Link url='/signup' text='Sign up'/>
            <Link url='/support' text='Support'/>
            <Link url='/terms' text='Terms'/>
            <Link url='/privacy' text='Privacy'/>
            </nav>

            <span>{ `Copyright © LedgerView ${new Date().getFullYear()}`}</span>
            <address></address>

          </Content>
        </Row>
      </footer>
    </Animate>
  );
}
